import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import Select from "react-select";
import axios from 'axios';
import arrow from "../../../../images/arrow.png";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import OrderBill from '../../Catering_Management/Manage_customer/Order_Bill';
import ReactDOMServer from 'react-dom/server';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CateringOrder = () => {
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [selectedOption, setSelectedOption] = useState(null);
    const [service_sttm, setServiceSTTMValue] = useState(new DateObject({ hour: 6, minute: 0, meridiem: 'AM' }));
    const [wastageType, setWastageType] = useState("food"); // default is food
    const [showAddOnSection, setShowAddOnSection] = useState(false); // For the Add-On Services section
    const [checkedItems, setCheckedItems] = useState({});
    const [cateringType, setCateringType] = useState({});
    const [functionType, setFunctionType] = useState({});
    const [addOnService, setAddOnService] = useState({});
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const [customer, setCustomer] = useState({});
    const [categorizedItems, setCategorizedItems] = useState([]);
    const [items, setItems] = useState({});
    const [selectedService, setSelectedService] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [quantity, setQuantity] = useState('');
    const [totalCost, setTotalCost] = useState(0);
    const [vendors, setVendors] = useState();
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst_percentage, setGstPercentage] = useState(0);
    const [confirmCost, setConfirmCost] = useState('');
    const [gstAmount, setGstAmount] = useState(0);
    const [totalWithGst, setTotalWithGst] = useState(0);
    const [itemQuantities, setItemQuantities] = useState({});
    const [coupon, setCoupon] = useState('');
    const [couponId, setCouponId] = useState(null);
    const [couponAmount, setCouponAmount] = useState(0);
    const navigate = useNavigate();
    const [selectedCateringType, setSelectedCateringType] = useState(null);
    const [selectedOrderDate, setSelectedOrderDate] = useState(null);
    const [selectedMealsPeriod, setSelectedMealsPeriod] = useState(null);
    const [selectedFunctionType, setSelectedFunctionType] = useState(null);
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [headCount, setHeadCount] = useState('');
    const [specialRequest, setSpecialRequest] = useState('');
    const [paymentClosingDate, setPaymentClosingDate] = useState(null);
    const [advanceAmount, setAdvanceAmount] = useState('');
    const [errors, setErrors] = useState({});
    const [units, setUnits] = useState([]);
    const [advanceAmountInput, setAdvanceAmountInput] = useState('');
    const [refundEligible, setRefundEligible] = useState(0);
    const [advancePercentage, setAdvancePercentage] = useState(0);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const { order } = location.state || {};


    const handleQuantityChangeForItem = (itemId, quantity) => {
        setItemQuantities(prev => ({
            ...prev,
            [itemId]: quantity,
        }));
    };

    const checkedItemsTotal = categorizedItems.reduce((sum, group) => {
        return (
            sum +
            group.items.reduce((groupSum, item) => {
                if (checkedItems[item.id]) {
                    const quantity = itemQuantities[item.id] || 0;
                    const cost = parseFloat(item.cost) || 0;
                    return groupSum + cost * quantity;
                }
                return groupSum;
            }, 0)
        );
    }, 0);

    const handleServiceChange = (selectedOption, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        selectedService: selectedOption,
                        costPerUnit: selectedOption?.cost_per_unit || 0,
                        totalCost: (selectedOption?.cost_per_unit || 0) * item.quantity
                    }
                    : item
            )
        );
    };

    const handleQuantityChange = (e, index) => {
        const quantity = parseFloat(e.target.value || 0);
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        quantity,
                        totalCost: quantity * (item.costPerUnit || 0)
                    }
                    : item
            )
        );
    };

    const handleVendorChange = (selectedVendor, index) => {
        setRawMatrial(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, selectedVendor }
                    : item
            )
        );
    };

    const fetchCateringType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.catering_type
                }));
                setCateringType(formatted);
            }
        } catch (error) {
            console.error('Failed to fetch Catering Type:', error);
            setCateringType([]);
        }
    };

    const fetchFunctionType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.function_type
                }));
                setFunctionType(formatted);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setFunctionType({});
        }
    };

    const fetchitemSchedule = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);

            const list = response.data?.data;

            if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
            } else {
                setMealsPeriod([]); // fallback to empty array
            }
        } catch (error) {
            console.error('Failed to fetch Meals period:', error);
            setMealsPeriod([]); // fallback to empty array, not object
        }
    };

    const fetchAddOnService = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/addonservice/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.service,
                    vendor: item.vendor,
                    cost_per_unit: item.cost_per_unit,
                }));
                setAddOnService(formatted);
            }
        } catch (error) {
            console.error('Failed to Add On Service Type:', error);
            setAddOnService({});
        }
    };

    const fetchCustomer = async (cust_id) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_customer/get/${cust_id}`);

            if (response.data) {
                setCustomer(response.data);
                // console.log(response.data);
            } else {
                console.error('No customer data found for this ID');
                setCustomer(null); // or however you want to handle no data
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
            setCustomer(null); // clear or reset state on error
        }
    };

    const fetchItems = async (scheduleID) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_order/get_items_by_schedule/${scheduleID}`);
            if (response.data?.data) {
                setItems(response.data.data);
                setCategorizedItems(response.data.data); // <-- Proper state update
                // console.log('Fetched categorized items:', response.data.data);
            } else {
                console.error('No items found for this schedule ID');
                setItems(null);
                setCategorizedItems([]);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setItems(null);
            setCategorizedItems([]);
            setLoading(false);
        }
    };

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const fetchVendors = async (branch_id) => {
        try {
            const response = await axios.get(`${BaseUrl}/manage_order/get_vendors/${branch_id}`);

            if (response.data?.data) {
                // Map the data to the required format
                const formattedVendors = response.data.data.map(vendor => ({
                    value: vendor.sno.toString(),             // or vendor.vendor_id if you want unique string id
                    label: vendor.vendor_businessname || 'Unknown Vendor',
                }));

                setVendors(formattedVendors);

                // Optional: console.log to check format
                // console.log('Formatted Vendors:', formattedVendors);
            } else {
                console.error('No vendors found for this branch ID');
                toast.error('Not Able to Fetch Vendors');
                setVendors([]);
            }
        } catch (error) {
            console.error('Error fetching vendors:', error);
            setVendors([]);
        }
    };

    const getGST = () => {
        axios.get(`${BaseUrl}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setGstPercentage(parseFloat(response.data.data.gst));
                    setRefundEligible(parseFloat(response.data.data.max_refund_eligible));
                    setAdvancePercentage(parseFloat(response.data.data.refund_deducted));
                } else {
                    console.log("Unexpected API response structure:", response);
                    setGstPercentage(5);
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
                setGstPercentage(5);
            });
    }


    const fetchUnits = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/manageunit/list/active`);
            if (response.data && response.data.data) {
                setUnits(response.data.data);  // <-- this is the array you want
            } else {
                setUnits([]);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setUnits([]);
        }
    };

    const getUnitSlugName = (unitId) => {
        if (!unitId) return '';
        const idNum = Number(unitId);
        if (isNaN(idNum)) return '';
        const matchedUnit = units.find(unit => Number(unit.sno) === idNum);
        // console.log('Looking for unitId:', idNum);
        // console.log('Matched unit:', matchedUnit);
        return matchedUnit ? matchedUnit.unitslug_name : '';
    };


    useEffect(() => {
        const customerId = localStorage.getItem('selectedCustomerId');
        fetchCustomer(customerId);
        fetchAddOnService();
        fetchFunctionType();
        fetchCateringType();
        fetchitemSchedule();
        fetchUnits();
        fetchVendors(branch_id);
        getGST();
    }, []);

    const handleAddOnToggle = (e) => {
        setShowAddOnSection(e.target.checked);
    };

    const handleItemCheckboxChange = (itemId, isChecked) => {
        setCheckedItems(prev => ({
            ...prev,
            [itemId]: isChecked,
        }));

        if (isChecked && headCount > 0) {
            const item = categorizedItems
                .flatMap(group => group.items)
                .find(i => i.id === itemId);

            if (item && item.per_person) {
                const qty = parseFloat(headCount) * parseFloat(item.per_person);
                setItemQuantities(prev => ({
                    ...prev,
                    [itemId]: Number(qty.toFixed(2)),
                }));
            }
        }
    };

    const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);

    const handleAddConfig = () => {
        setRawMatrial([...rawMatrial, { id: Date.now() }]);
    };

    const handleDeleteConfig = (id) => {
        setRawMatrial(rawMatrial.filter(config => config.id !== id));
    };

    const updateCostValues = (value) => {
        if (/^\d*\.?\d*$/.test(value)) {
            setConfirmCost(value);
            const costNumber = parseFloat(value) || 0;
            const gst = (costNumber * gst_percentage) / 100;
            setGstAmount(gst);
            setTotalWithGst(costNumber + gst);
            const autoAdvance = (costNumber * advancePercentage) / 100;
            setAdvanceAmount(autoAdvance);
            setAdvanceAmountInput(autoAdvance);
        }
    };

    // Call this on input change
    const handleConfirmCostChange = (e) => {
        updateCostValues(e.target.value);
    };

    // Run this on page load (or when gst_percentage changes, or confirmCost changes)
    useEffect(() => {
        updateCostValues(confirmCost);
    }, [gst_percentage]); // also add confirmCost if needed



    useEffect(() => {
        const costNumber = parseFloat(confirmCost) || 0;
        const gst = (costNumber * gst_percentage) / 100;
        setGstAmount(gst);
        setTotalWithGst(costNumber + gst);
    }, [confirmCost, gst_percentage]);


    useEffect(() => {
        const rawMaterialTotal = showAddOnSection
            ? rawMatrial.reduce((sum, item) => sum + (item.totalCost || 0), 0)
            : 0;

        const checkedItemsTotal = categorizedItems.reduce((sum, group) => {
            return (
                sum +
                group.items.reduce((groupSum, item) => {
                    if (checkedItems[item.id]) {
                        const quantity = itemQuantities[item.id] || 0;
                        const cost = parseFloat(item.cost) || 0;
                        return groupSum + cost * quantity;
                    }
                    return groupSum;
                }, 0)
            );
        }, 0);

        setGrandTotal(rawMaterialTotal + checkedItemsTotal);
    }, [rawMatrial, checkedItems, itemQuantities, categorizedItems, showAddOnSection]);


    const selectedItems = categorizedItems.flatMap(group =>
        group.items
            .filter(item => checkedItems[item.id])
            .map(item => {
                const quantity = itemQuantities[item.id] || 0;
                // console.log(`Item ID: ${item.id}, Quantity: ${quantity}`);
                return {
                    id: item.id,
                    name: item.name,
                    quantity: quantity > 0 ? quantity : 1,
                    category: group.category,
                    sub_category: group.sub_category,
                    cost: item.cost || 0,
                    measurement_quantity: item.measurement_quantity,
                };
            })
    );


    const handleApplyClick = () => {
        if (!coupon) {
            toast.error('Coupon Code is Required.');
            return;
        }

        const filter = {
            coupon_code: coupon,
            coupon_for: 1,
        };

        axios.get(`${BaseUrl}/coupon/code`, { params: filter })
            .then(response => {
                const data = response.data.data;
                if (data) {
                    setCouponId(data.sno);

                    let discountValue = 0;
                    if (data.coupon_type === 0) {
                        // fixed amount discount
                        discountValue = parseFloat(data.coupon_value);
                    } else if (data.coupon_type === 1) {
                        // percentage discount
                        const percentage = parseFloat(data.coupon_value);
                        discountValue = confirmCost * (percentage / 100);
                    }

                    setCouponAmount(discountValue);

                    // Calculate new amount after discount
                    const discountedAmount = confirmCost - discountValue;

                    // Calculate GST on discounted amount
                    const newGstAmount = discountedAmount * (gst_percentage / 100);

                    setGstAmount(newGstAmount);

                    // Calculate new total including GST
                    const newTotal = discountedAmount + newGstAmount;

                    setTotalWithGst(newTotal);
                } else {
                    setCouponAmount(0);
                    toast.error('Coupon not valid or expired');
                    setCouponId(null);
                }
            })
            .catch(error => {
                setCouponAmount(0);
                console.error('There was an error fetching the data!', error);
                toast.error('Error fetching coupon. Please try again.');
                setCouponId(null);
            });
    };

    // useEffect(() => {
    //     if (coupon) {
    //         const timeoutId = setTimeout(() => {
    //         handleApplyClick();
    //         }, 5000); // 2000 ms = 2 seconds

    //         return () => clearTimeout(timeoutId); // cleanup if coupon changes or component unmounts
    //     }
    // }, [coupon]);

    const validateForm = () => {
        const newErrors = {};
        const today = new Date();
        today.setHours(0, 0, 0, 0); // reset to midnight for date comparison

        // Catering Type required
        if (!selectedCateringType) {
            newErrors.selectedCateringType = "Catering Type is required";
        }

        // Order Date required & can't be before today
        if (!selectedOrderDate) {
            newErrors.selectedOrderDate = "Order Date is required";
        }

        // Order Time required
        if (!service_sttm) {
            newErrors.service_sttm = "Order Time is required";
        }

        // Meals Period required
        if (!selectedMealsPeriod) {
            newErrors.selectedMealsPeriod = "Meals Period is required";
        }

        // Function Type required
        if (!selectedFunctionType) {
            newErrors.selectedFunctionType = "Function Type is required";
        }

        // Delivery Address required and non-empty
        if (!deliveryAddress || !deliveryAddress.trim()) {
            newErrors.deliveryAddress = "Delivery Address is required";
        }

        // Head Count must be a number > 0
        if (!headCount || isNaN(headCount) || Number(headCount) <= 0) {
            newErrors.headCount = "Please enter a valid Head Count (number > 0)";
        }

        // Payment Closing Date required and must be today or after
        if (!paymentClosingDate) {
            newErrors.paymentClosingDate = "Payment Closing Date is required";
        }

        Object.entries(checkedItems).forEach(([itemId, isChecked]) => {
            if (isChecked) {
                const qty = itemQuantities[itemId];
                if (!qty || isNaN(qty) || Number(qty) <= 0) {
                    newErrors[`itemQuantity_${itemId}`] = "Please enter valid quantity (>0)";
                }
            }
        });

        // Validate add-on services if visible
        if (showAddOnSection) {
            rawMatrial.forEach((config, idx) => {
                if (!config.selectedService) {
                    newErrors[`addOnService_${idx}`] = "Service is required";
                }
                if (config.selectedService && config.selectedService.vendor === 0 && !config.selectedVendor) {
                    newErrors[`addOnVendor_${idx}`] = "Vendor is required";
                }
                if (!config.quantity || isNaN(config.quantity) || Number(config.quantity) <= 0) {
                    newErrors[`addOnQuantity_${idx}`] = "Enter valid units (>0)";
                }
                if (
                    config.totalCost === undefined ||
                    config.totalCost === null ||
                    isNaN(config.totalCost) ||
                    Number(config.totalCost) < 0
                ) {
                    newErrors[`addOnCost_${idx}`] = "Enter valid total cost (>= 0)";
                }
            });
        }

        const parsedConfirmCost = parseFloat(confirmCost);

        if (isNaN(parsedConfirmCost) || parsedConfirmCost < 0) {
            newErrors.confirmCost = "Confirm Cost must be a positive number or zero";
        }

        const parsedAdvanceAmount = parseFloat(advanceAmountInput);


        if (
            advanceAmountInput == '' ||
            isNaN(parsedAdvanceAmount)
        ) {
            newErrors.advanceAmount = "Advance Amount is required";
        } else if (parsedAdvanceAmount < advanceAmount) {
            newErrors.advanceAmount = `Advance Amount must be ₹${advanceAmount} or more`;
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        setErrors(null);

        if (!validateForm()) {
            return;
        }

        const addOnServices = showAddOnSection
            ? rawMatrial
                .filter(config => config.selectedService)
                .map(config => ({
                    service: config.selectedService.value,
                    vendor: config.selectedVendor ? config.selectedVendor.value : null,
                    quantity: config.quantity,
                    totalCost: config.totalCost,
                }))
            : [];

        const dataToSend = {
            cateringType: selectedCateringType.value,
            orderDate: new Date(selectedOrderDate).toLocaleDateString('en-CA'),
            orderTime: new Date(service_sttm).toTimeString().slice(0, 5),
            mealsPeriod: selectedMealsPeriod.value,
            functionType: selectedFunctionType.value,
            deliveryAddress: deliveryAddress.trim(),
            headCount: Number(headCount),
            specialRequest: specialRequest.trim(),
            paymentClosingDate: new Date(paymentClosingDate).toLocaleDateString('en-CA'),
            addOnService: addOnServices,
            items: selectedItems,
            advanceAmount: Number(advanceAmount),
            confirmCost: Number(confirmCost),
            coupon: coupon,
            branch_id: branch_id,
            customer_id: customer.sno,
            total: totalWithGst,
            gst: gstAmount,
            couponamount: couponAmount,
        };

        // console.log("Prepared data to send:", JSON.stringify(dataToSend, null, 2));

        try {
            const user_id = parseInt(localStorage.getItem("user_id"), 10);

            if (!order || !order.id) {
                toast.error('Order ID is missing. Cannot update.');
                return;
            }

            // Change POST to PUT and include order id in URL
            const response = await fetch(`${BaseUrl}/manage_order/confirm_order/${order.id}/${user_id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (!response.ok) {
                const errorData = await response.json();
                toast.error('Failed to update order');
                console.error('Update error:', errorData);
                return;
            }
            handlePrint(1);
            const result = await response.json();
            toast.success('Order updated successfully!');
            navigate('/manage-catering-order');
        } catch (error) {
            setErrors(error.message);
            toast.error('Error updating order. Please try again.');
        }
    };


    useEffect(() => {
        if (!order) return;

        // Only proceed if addOnService and vendors options are loaded
        if (!Array.isArray(addOnService) || addOnService.length === 0) return;
        if (!Array.isArray(vendors) || vendors.length === 0) return;

        let parsedAddOnService = [];
        try {
            if (typeof order.addonservice === 'string') {
                parsedAddOnService = JSON.parse(order.addonservice || '[]');
            } else if (Array.isArray(order.addonservice)) {
                parsedAddOnService = order.addonservice;
            }
        } catch (e) {
            console.error("Invalid addonservice JSON:", e);
        }

        const mappedRawMatrial = parsedAddOnService.map((item, idx) => {
            const selectedService = addOnService.find(s => String(s.value) === String(item.service)) || null;
            const selectedVendor = selectedService?.vendor === 0
                ? vendors.find(v => String(v.value) === String(item.vendor)) || null
                : null;

            return {
                id: idx + 1,
                selectedService,
                selectedVendor,
                quantity: item.quantity,
                totalCost: item.totalCost,
                costPerUnit: selectedService ? parseFloat(selectedService.cost) || 0 : 0,  // set cost per unit here
            };
        });

        setRawMatrial(mappedRawMatrial);
        setShowAddOnSection(mappedRawMatrial.length > 0);

        // Parse and set checked items from order
        let parsedItems = [];
        try {
            if (typeof order.items === 'string') {
                parsedItems = JSON.parse(order.items || '[]');
            } else if (Array.isArray(order.items)) {
                parsedItems = order.items;
            }
            setItems(parsedItems);

            const initialCheckedItems = {};
            const initialQuantities = {};
            parsedItems.forEach(item => {
                initialCheckedItems[item.id] = true;
                initialQuantities[item.id] = item.quantity || 0;
            });
            setCheckedItems(initialCheckedItems);
            setItemQuantities(initialQuantities);
        } catch (e) {
            console.error("Failed to parse items", e);
        }


        // Set other order fields
        setCustomer(order.customer || {});
        setConfirmCost(order.confirm_cost || '');
        setAdvanceAmount(order.advance_amount || '');
        setDeliveryAddress(order.delivery_address || '');
        setHeadCount(order.head_count || '');
        setSpecialRequest(order.special_request || '');
        setCoupon(order.coupon || '');


        // Set select dropdowns carefully, assuming these are already fetched options arrays
        if (cateringType.length) {
            const selected = cateringType.find(opt => String(opt.value) === String(order.catering_type));
            setSelectedCateringType(selected || null);
        }
        if (functionType.length) {
            const selected = functionType.find(opt => String(opt.value) === String(order.function_type));
            setSelectedFunctionType(selected || null);
        }
        if (mealsPeriod.length) {
            const selected = mealsPeriod.find(opt => String(opt.value) === String(order.meals_period));
            setSelectedMealsPeriod(selected || null);
            fetchItems(order.meals_period);
        }

        setSelectedOrderDate(order.order_date ? new DateObject(order.order_date) : null);
        setPaymentClosingDate(order.payment_closing_date ? new DateObject(order.payment_closing_date) : null);
        setServiceSTTMValue(((t) => { const d = new Date();[d.setHours, d.setMinutes, d.setSeconds].forEach((fn, i) => fn.call(d, t.split(':')[i] || 0)); return d; })(order.order_time));


        setGrandTotal(Number(order.total) || 0);
        setGstPercentage(Number(order.gst_percentage) || 0);
        setGstAmount(Number(order.gst_amount) || 0);
        setTotalWithGst(Number(order.total_with_gst) || 0);

    }, [order, addOnService, vendors, cateringType, functionType, mealsPeriod]);

    const selectedItemsForPrint = selectedItems.map(item => ({
        name: item.name,
        quantity: `${item.quantity} ${getUnitSlugName(item.measurement_quantity)}`,
        pricePerQty: parseFloat(item.cost).toFixed(2),
        total: (item.quantity * item.cost).toFixed(2),
    }));


    const addOnServicesForPrint = rawMatrial
        .filter(item => item.selectedService && item.quantity > 0)
        .map(item => {
            const costPerUnit = parseFloat(item.selectedService?.cost_per_unit) || 0;
            const totalCost = parseFloat(item.totalCost) || costPerUnit * item.quantity;

            // console.log('costPerUnit:', costPerUnit, 'totalCost:', totalCost);

            return {
                name: item.selectedService.label,
                quantity: item.quantity,
                costPerUnit: costPerUnit.toFixed(2),
                total: totalCost.toFixed(2),
            };
        });


    const print_order = {
        orderDate: selectedOrderDate ? moment(selectedOrderDate).format("DD-MM-YYYY") : "",
        orderNumber: order.customer['customer_name'],
        orderId: order.id,
        totalCost: grandTotal.toFixed(2),
        confirmCost: parseFloat(confirmCost || 0).toFixed(2),
        advanceAmount: parseFloat(advanceAmount || 0).toFixed(2),
        couponAmount: parseFloat(couponAmount || 0).toFixed(2),
        gstAmount: gstAmount.toFixed(2),
        grandTotal: (parseFloat(confirmCost || 0) + gstAmount).toFixed(2),
    };

    const handlePrint = (download = 0) => {
        const orderData = {
            orderDate: print_order?.orderDate,
            orderNumber: print_order?.orderNumber,
            orderId: print_order?.orderId,
            selectedItems: selectedItemsForPrint || [],
            addOnServices: addOnServicesForPrint || [],
            totalCost: print_order?.totalCost || 0,
            confirmCost: print_order?.confirmCost || 0,
            advanceAmount: print_order?.advanceAmount || 0,
            couponAmount: print_order?.couponAmount || 0,
            gstAmount: print_order?.gstAmount || 0,
            grandTotal: totalWithGst || 0,
            gst_percentage: gst_percentage,
            download: download,
        };

        fetch(`${BaseUrl}/manage_order/preview_pdf`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(orderData),
        })
            .then(response => {
                if (download === 0) {
                    if (response.headers.get('Content-Type') === 'application/pdf') {
                        return response.blob();
                    }
                    throw new Error('PDF preview failed.');
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (download === 0) {
                    const url = URL.createObjectURL(data);
                    window.open(url, '_blank');
                } else {
                    console.log('PDF saved to:', data.path);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                toast.error('PDF generation failed.');
            });
    };

    if (loading) {
        return (
            <>
                <div className="container-fluid">
                    {/* Page header skeleton */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                        <div className="mb-2">
                            <div className="mb-0 px-0">
                                <h4 style={{ color: "#025d3a" }}>
                                    <Skeleton width={150} />
                                </h4>
                            </div>
                            <ol className="breadcrumb fs-7">
                                <li className="breadcrumb-item">
                                    <Skeleton width={70} />
                                </li>
                                <li className="breadcrumb-item">
                                    <Skeleton width={20} />
                                </li>
                                <li className="breadcrumb-item active">
                                    <Skeleton width={100} />
                                </li>
                            </ol>
                        </div>
                        <div className="d-flex align-items-center gap-3 flex-wrap mb-2">
                            <Skeleton width={30} height={30} borderRadius={12} />
                            <Skeleton width={100} />
                            <Skeleton width={30} height={30} borderRadius={12} />
                            <Skeleton width={100} />
                        </div>
                    </div>

                    {/* Order Details Form Skeleton */}
                    <div className="row mb-2">
                        <h4 className="font-w600 text-black">
                            <Skeleton width={160} />
                        </h4>

                        {Array.from({ length: 8 }).map((_, i) => (
                            <div className="col-lg-3 mb-4" key={i}>
                                <Skeleton width={120} height={16} />
                                <Skeleton height={40} borderRadius={6} className="mt-2" />
                            </div>
                        ))}
                    </div>

                    {/* Items list skeleton */}
                    <div className="row mb-2">
                        <h4 className="font-w600 text-black">
                            <Skeleton width={140} />
                        </h4>
                        <div className="col-lg-12 mb-2">
                            <div className="row scroll-y mh-450px py-2">
                                {Array.from({ length: 6 }).map((_, i) => (
                                    <div className="col-lg-3 mb-3" key={i}>
                                        <Skeleton width={100} height={14} />
                                        <Skeleton height={20} width={180} className="mt-2" />
                                        <Skeleton height={38} borderRadius={6} className="mt-3" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Add-on Services skeleton */}
                    <div className="row mb-2">
                        <h4 className="font-w600 text-black">
                            <Skeleton width={160} />
                        </h4>
                        {Array.from({ length: 2 }).map((_, index) => (
                            <div className="col-lg-12 mb-3" key={index}>
                                <div className="row">
                                    {Array.from({ length: 4 }).map((__, i) => (
                                        <div className="col-lg-3 mb-3" key={i}>
                                            <Skeleton width={120} height={14} />
                                            <Skeleton height={40} borderRadius={6} className="mt-2" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                        <div className="mt-3">
                            <Skeleton width={120} height={35} borderRadius={8} />
                        </div>
                    </div>

                    {/* Summary section skeleton */}
                    <div className="row mx-2 my-2">
                        <div className="col-lg-6">
                            <div
                                className="p-4 rounded"
                                style={{
                                    backgroundColor: "#f0f5ef",
                                    maxHeight: "350px",
                                    overflowY: "auto",
                                }}
                            >
                                <h5 className="text-black font-w600 mb-3">
                                    <Skeleton width={140} />
                                </h5>
                                {Array.from({ length: 4 }).map((_, i) => (
                                    <div
                                        key={i}
                                        className="d-flex justify-content-between align-items-center mb-2"
                                    >
                                        <Skeleton width={140} height={20} />
                                        <Skeleton width={80} height={20} />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div
                                className="d-flex flex-column align-items-end justify-content-end py-4 px-4 rounded"
                                style={{ backgroundColor: "#f0f5ef" }}
                            >
                                {Array.from({ length: 5 }).map((_, i) => (
                                    <div className="col-lg-10 mb-3" key={i}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <Skeleton width={140} height={20} />
                                            <Skeleton width={100} height={25} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Bottom buttons */}
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Skeleton width={130} height={35} borderRadius={6} />
                        <Skeleton width={130} height={35} borderRadius={6} />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Catering Order</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Catering Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Customer</li>
                    </ol>
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 bg-gray-300 py-2 px-2 rounded">
                    {customer ? (
                        <div className="d-flex flex-column">
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Basmathi Rice</span></Tooltip>} >
                                <label className='text-danger font-w500 fs-5 text-truncate w-150px'>{customer.customer_name}</label>
                            </OverlayTrigger>
                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Brand/Quantity</span></Tooltip>} >
                                <label className='text-black font-w400 fs-7'>{customer.customer_number}</label>
                            </OverlayTrigger>
                        </div>
                    ) : (<div></div>)}
                </div>
            </div>
            <div className='row mb-2'>
                <h4 className='font-w600 text-black'>Order Details</h4>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Catering Type<span className="required">*</span></label>
                    <Select
                        placeholder='Select Catering Type'
                        onChange={setSelectedCateringType}
                        options={cateringType}
                        value={selectedCateringType}
                    />
                    {errors.selectedCateringType && (
                        <small className="text-danger">{errors.selectedCateringType}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Order Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Date'
                            value={selectedOrderDate}
                            onChange={setSelectedOrderDate}
                            format="DD-MM-YYYY"
                            readOnly
                        />
                    </div>
                    {errors.selectedOrderDate && (
                        <small className="text-danger">{errors.selectedOrderDate}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Order Time<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex border-bottom border-gray-300'>
                        <div className='input-group-text bg-transparent border-0 px-0'>
                            <i className='fa-solid fa-clock fs-4'></i>
                        </div>
                        <DatePicker placeholder='Select Time'
                            disableDayPicker
                            value={service_sttm}
                            onChange={setServiceSTTMValue}
                            format="HH:mm"
                            plugins={[
                                <TimePicker hideSeconds />
                            ]}
                        />
                    </div>
                    {errors.service_sttm && (
                        <small className="text-danger">{errors.service_sttm}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Meals Period<span className="required">*</span></label>
                    <Select
                        placeholder='Select Meals Period'
                        onChange={(selectedOption) => {
                            setSelectedMealsPeriod(selectedOption);
                            fetchItems(selectedOption.value);
                        }}
                        options={mealsPeriod}
                        value={selectedMealsPeriod}
                    />
                    {errors.selectedMealsPeriod && (
                        <small className="text-danger">{errors.selectedMealsPeriod}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Function Type<span className="required">*</span></label>
                    <Select placeholder='Select Function Type'
                        onChange={setSelectedFunctionType}
                        options={functionType}
                        value={selectedFunctionType}
                    />
                    {errors.selectedFunctionType && (
                        <small className="text-danger">{errors.selectedFunctionType}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Delivery Address<span className="required">*</span></label>
                    <textarea className="form-control" placeholder="Enter Delivery Address" value={deliveryAddress} onChange={e => setDeliveryAddress(e.target.value)} />
                    {errors.deliveryAddress && (
                        <small className="text-danger">{errors.deliveryAddress}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Head Count (in No's)<span className="required">*</span></label>
                    <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control"
                        placeholder="Enter Head Count"
                        value={headCount}
                        onChange={e => {
                            const val = e.target.value;
                            if (/^\d*$/.test(val)) {
                                setHeadCount(val);
                            }
                        }}
                    />
                    {errors.headCount && (
                        <small className="text-danger">{errors.headCount}</small>
                    )}
                </div>
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Special Request (if Any)</label>
                    <textarea className="form-control" value={specialRequest} onChange={e => setSpecialRequest(e.target.value)} placeholder="Enter Special Request" />
                </div>
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Payment Closing Date<span className="required">*</span></label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker placeholder='Select Date'
                            value={paymentClosingDate}
                            onChange={setPaymentClosingDate}
                            format="DD-MM-YYYY"

                        />
                    </div>
                    {errors.paymentClosingDate && (
                        <small className="text-danger">{errors.paymentClosingDate}</small>
                    )}
                </div>
            </div>
            {categorizedItems.map((group, index) => (
                <div className='row mb-2' key={index}>
                    <h4 className='font-w600 text-black'>List Of Items</h4>
                    <div className='col-lg-12 mb-2'>
                        <div className='row scroll-y mh-450px py-2'>
                            <div key={index}>
                                <label className="fs-6 text-primary mb-0 mt-2 font-w600">{group.category}</label>
                                <label className="fs-6 text-primary mb-0 mt-2 font-w600">{group.sub_category}</label>
                                <div className="row">
                                    {group.items.map((item) => (
                                        <div className="col-lg-3" key={item.id}>
                                            <div className='form-check-inline mt-3'>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value={item.name}
                                                    onChange={(e) => handleItemCheckboxChange(item.id, e.target.checked)}
                                                    checked={checkedItems[item.id] || false}
                                                    id={`item-${item.id}`}
                                                />
                                                <label className="fs-7 text-black mb-0 font-w500" htmlFor={`item-${item.id}`}>
                                                    {item.name} <span className="fs-9">({getUnitSlugName(item.measurement_quantity)})</span>
                                                </label>
                                            </div>

                                            {checkedItems[item.id] && (
                                                <div className='d-block'>
                                                    <div className="col-lg-12 mb-2 mt-2">
                                                        <input
                                                            type="text"
                                                            inputMode='numeric'
                                                            pattern="[0-9]*"
                                                            className="form-control"
                                                            placeholder={`Enter Count for ${item.name}`}
                                                            value={itemQuantities[item.id] || ''}
                                                            onChange={(e) =>
                                                                setItemQuantities((prev) => ({
                                                                    ...prev,
                                                                    [item.id]: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                        {errors[`itemQuantity_${item.id}`] && (
                                                            <small className="text-danger">{errors[`itemQuantity_${item.id}`]}</small>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            <div className='row mb-2'>
                <div className='col-lg-12 mb-2'>
                    <div className="form-check custom-checkbox mt-3">
                        <input
                            type="checkbox"
                            onChange={handleAddOnToggle}
                            className="form-check-input me-3"
                            id="customCheckBox1"
                            checked={showAddOnSection}
                        />
                        <h4 className='font-w600 text-black' htmlFor="customCheckBox1">Add-On Services</h4>
                    </div>
                </div>
                {showAddOnSection && (
                    <>
                        {rawMatrial.map((config, index) => (
                            <div key={config.id} data-repeater-item>
                                <div className='row mb-2'>
                                    <div className='col-lg-11'>
                                        <div className='row'>
                                            <div className='col-lg-3 mb-2'>
                                                <label className="text-black font-w500 fs-7">Service<span className="required">*</span></label>
                                                <Select
                                                    placeholder='Select Service'
                                                    value={config.selectedService}
                                                    onChange={(option) => handleServiceChange(option, index)}
                                                    options={addOnService}
                                                />
                                                {errors[`addOnService_${index}`] && (
                                                    <small className="text-danger">{errors[`addOnService_${index}`]}</small>
                                                )}
                                            </div>

                                            {config.selectedService?.vendor === 0 && (
                                                <div className='col-lg-3 mb-2'>
                                                    <label className="text-black font-w500 fs-7">Vendor<span className="required">*</span></label>
                                                    <Select
                                                        placeholder='Select Vendor'
                                                        value={config.selectedVendor}
                                                        onChange={(option) => handleVendorChange(option, index)}
                                                        options={vendors}
                                                    />
                                                    {errors[`addOnVendor_${index}`] && (
                                                        <small className="text-danger">{errors[`addOnVendor_${index}`]}</small>
                                                    )}
                                                </div>
                                            )}

                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">No Of Units<span className="required">*</span></label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Units"
                                                    value={config.quantity}
                                                    onChange={(e) => handleQuantityChange(e, index)}
                                                />
                                                {errors[`addOnQuantity_${index}`] && (
                                                    <small className="text-danger">{errors[`addOnQuantity_${index}`]}</small>
                                                )}
                                            </div>

                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Total Cost<span className="required"></span></label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Total Cost"
                                                    value={(config.totalCost || 0).toFixed(2)}
                                                    readOnly
                                                    disabled
                                                />
                                                {errors[`addOnCost_${index}`] && (
                                                    <small className="text-danger">{errors[`addOnCost_${index}`]}</small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-1 mb-1 px-1 py-1">
                                        {rawMatrial.length > 1 && (
                                            <button
                                                className="btn btn-danger mt-4 px-2 py-2"
                                                onClick={() => handleDeleteConfig(config.id)}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Delete"
                                            >
                                                <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="mb-1 mt-1">
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={handleAddConfig}
                            >
                                <span><i className="fa-solid fa-plus fs-6"></i></span>
                                <span className='ms-2 fs-7'>Add More</span>
                            </button>
                        </div>
                    </>
                )}
            </div>
            <div className='row mx-2 my-2'>
                <div className='col-lg-6'>
                    <div
                        className="p-4 rounded"
                        style={{
                            backgroundColor: '#f0f5ef',
                            maxHeight: '350px',
                            overflowY: 'auto',
                        }}
                        id="printableArea"  // Add this ID for printing
                    >
                        <h5 className="text-black font-w600 mb-3">Selected Items</h5>
                        <ul className="list-group">
                            {Object.entries(checkedItems).map(([itemId, isChecked]) => {
                                if (isChecked) {
                                    const item = categorizedItems
                                        .flatMap(group => group.items)
                                        .find(i => i.id.toString() === itemId.toString());
                                    return (
                                        item && (
                                            <li
                                                key={itemId}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                <div>
                                                    <span className='fs-7' style={{ color: '#333', fontWeight: 600 }}>{item.name}</span>
                                                    <br />
                                                    <span className='fs-8' style={{ color: '#242424ff', fontWeight: 500 }}>
                                                        {itemQuantities[itemId] || 0} {getUnitSlugName(item.measurement_quantity)}
                                                    </span>
                                                </div>
                                                <span className="badge bg-primary fs-7 rounded-pill">
                                                    ₹ {(parseFloat(item.cost || 0) * (itemQuantities[itemId] || 0)).toFixed(2)}
                                                </span>
                                            </li>
                                        )
                                    );
                                }
                                return null;
                            })}
                        </ul>

                        {/* Optional: Add-on services summary */}
                        {showAddOnSection && rawMatrial.length > 0 && (
                            <>
                                <h6 className="text-black font-w600 mb-2 mt-4">Add-On Services</h6>
                                <ul className="list-group">
                                    {rawMatrial.map((config, index) => (
                                        config.selectedService && (
                                            <li
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                <div>
                                                    <span className='fs-7' style={{ color: '#333', fontWeight: 600 }}>
                                                        {config.selectedService.label}
                                                    </span>
                                                    <br />
                                                    <span className='fs-8' style={{ color: '#242424ff', fontWeight: 500 }}>
                                                        {config.quantity || 0} unit(s)
                                                    </span>
                                                </div>
                                                <span className="badge bg-secondary fs-7 rounded-pill">
                                                    ₹ {(parseFloat(config.selectedService.cost_per_unit || 0) * (config.quantity || 0)).toFixed(2)}
                                                </span>
                                            </li>
                                        )
                                    ))}
                                </ul>
                            </>
                        )}

                    </div>
                </div>
                <div className='col-lg-6'>
                    <div className='d-flex flex-column align-items-end justify-content-end py-4 px-4 rounded' style={{ backgroundColor: '#f0f5ef' }}>
                        <div className="col-lg-10 mb-2">
                            <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                <label className="text-black font-w500 fs-5">Total Cost<span className="required"></span></label>
                                <span className='align-items-start text-black font-w500 fs-3'>{grandTotal.toFixed(2)}</span>
                            </div>
                        </div>
                        <div className="col-lg-10 mb-2">
                            <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                <label className="text-black font-w500 fs-5">Confirm Cost<span className="required">*</span></label>
                                <input type="text" className="form-control text-black" placeholder="Enter Confirm Cost" style={{ width: '50%' }} value={confirmCost} onChange={handleConfirmCostChange} />
                            </div>
                            {errors.confirmCost && (
                                <small className="text-danger">{errors.confirmCost}</small>
                            )}
                        </div>
                        <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement="bottom"
                            overlay={
                                <Tooltip className='tooltip-popover'>
                                    <span className='fs-9 text-white fw-semibold'>
                                        Based On Refund Eligible
                                    </span>
                                </Tooltip>
                            }
                        >
                            <div className="col-lg-10 mb-2">
                                <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                    <label className="text-black font-w500 fs-5">
                                        Advance Amount<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        className="form-control text-black"
                                        placeholder="Enter Advance Amount"
                                        style={{ width: '50%' }}
                                        value={advanceAmount}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setAdvanceAmountInput(value);
                                            setAdvanceAmount(value);

                                            const parsed = parseFloat(value);
                                            if (value === "" || isNaN(parsed)) {
                                                setErrors(prev => ({
                                                    ...prev,
                                                    advanceAmount: "Advance Amount is required",
                                                }));
                                            } else if (parsed < advanceAmount) {
                                                setErrors(prev => ({
                                                    ...prev,
                                                    advanceAmount: `Advance Amount must be ₹${advanceAmount} or more`,
                                                }));
                                            } else {
                                                setErrors(prev => ({ ...prev, advanceAmount: null }));
                                            }
                                        }}
                                    />
                                </div>
                                {errors.advanceAmount && (
                                    <small className="text-danger">{errors.advanceAmount}</small>
                                )}
                            </div>
                        </OverlayTrigger>
                        <div className="col-lg-10 mb-2">
                            <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                <label className="text-black font-w500 fs-5">
                                    Discount Coupon<span className="required"></span>
                                </label>
                                <div className="d-flex gap-2 w-50">
                                    <input type="text" className="form-control text-black" placeholder="Enter Coupon" style={{ flex: 1, width: '5%' }} value={coupon} onChange={e => setCoupon(e.target.value)} />
                                    <button type="button" className="btn btn-sm btn-primary" style={{ whiteSpace: 'nowrap' }}><img src={arrow} alt='submit' onClick={handleApplyClick} /></button>
                                </div>
                            </div>
                        </div>
                        {couponAmount ? (
                            <div className="col-lg-10 mb-2">
                                <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                    <label className="text-black font-w500 fs-5">
                                        Coupon Amount
                                        <span className="required"></span>
                                    </label>
                                    <span className='align-items-start text-black font-w500 fs-3'>{couponAmount.toFixed(2)}</span>
                                </div>
                            </div>
                        ) : null}


                        <div className="col-lg-10 mb-2">
                            <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                <label className="text-black font-w500 fs-5">GST Amount<span className="required"></span>
                                    <span className='d-block'>({gst_percentage}%)</span></label>
                                <span className='align-items-start text-black font-w500 fs-3'>{gstAmount.toFixed(2)}</span>
                            </div>
                        </div>
                        <div className="col-lg-10 mb-2">
                            <div className='d-flex flex-row gap-2 align-items-center justify-content-between'>
                                <label className="text-danger font-w500 fs-4">Grand Total<span className="required"></span></label>
                                <span className='align-items-start text-red font-w500 fs-2'>{totalWithGst.toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => handlePrint(0)}
                >
                    Preview Invoice
                    <i className="fas fa-file-alt ms-2"></i>
                </button>
                <button type="button" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                    Confirm Order
                    <i className="fas fa-angle-double-right ms-2"></i>
                </button>
            </div>

            {/* <div
                id="printableDiv"
                style={{
                    margin: 0,
                    padding: 0,
                    boxSizing: 'border-box',
                }}
            >
                <OrderBill
                    orderDate={print_order?.orderDate}
                    orderNumber={print_order?.orderNumber}
                    selectedItems={selectedItemsForPrint || []}
                    addOnServices={addOnServicesForPrint || []}
                    totalCost={print_order?.totalCost || 0}
                    confirmCost={print_order?.confirmCost || 0}
                    advanceAmount={print_order?.advanceAmount || 0}
                    couponAmount={print_order?.couponAmount || 0}
                    gstAmount={print_order?.gstAmount || 0}
                    grandTotal={totalWithGst || 0}
                />
            </div> */}

        </>
    )


}
export default CateringOrder;